export const PLATFORM = {
  WEB: 'WEB',
  MOBILE: 'MOBILE'
}

export enum SEND_MESSAGE_ALERT_TYPE {
  OPTIN = 'OPTIN',
  BLOCK_CONTACT = 'BLOCK_CONTACT'
}

export type SEND_MESSAGE_ALERT_BODY = {
  message: string
}

export const SEND_MESSAGE_ALERT: Record<SEND_MESSAGE_ALERT_TYPE, SEND_MESSAGE_ALERT_BODY> = {
  OPTIN: {
    message:
      'ATENÇÃO: Consta no cadastro deste cliente que ele não autoriza ser contactado. De acordo com a LGPD, você não\n' +
      'deveria iniciar uma conversa. Tem certeza que deseja continuar?'
  },
  BLOCK_CONTACT: {
    message: 'Este contato está bloqueado, deseja desbloquear e continuar?'
  }
}

export const SOURCE_TYPES: Record<string, { name: string; description: string }> = {
  DEFAULT: {
    name: 'DEFAULT',
    description: ''
  },
  AD: {
    name: 'AD',
    description: 'Enviada via anúncio'
  },
  POST: {
    name: 'POST',
    description: 'Enviada via publicação'
  },
  ECHO: {
    name: 'ECHO',
    description: 'Enviada via WhatsApp Business App'
  }
}

export const orderOptions = [
  { value: 'pix_dynamic_code', label: 'Pix' },
  { value: 'payment_link', label: 'Link de cobrança' },
  { value: 'boleto', label: 'Boleto' }
]

export const REALM_NAMES_MAPPER: { originalName: string; newName: string }[] = [
  { originalName: 'Chevrolet', newName: 'Portal Tecsinapse' }
]

export type PaymentType = 'pix_dynamic_code' | 'payment_link' | 'boleto'
